(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cwm-article-image-sizing"]) return;
  try {
    
(function () {
  function classifyImage(image, isHero) {
    function applyClass() {
      if (!image.naturalWidth || !image.naturalHeight) return;
      if (image.naturalHeight >= image.naturalWidth) {
        image.classList.add('cwm-image-portrait');
        if (isHero) {
          var heroContainer = image.closest('.article-template__hero-container');
          if (heroContainer) heroContainer.classList.add('cwm-image-portrait');
        } else {
          var figure = image.closest('figure');
          if (figure) figure.classList.add('cwm-portrait-figure');
        }
      }
    }

    if (image.complete) {
      applyClass();
    } else {
      image.addEventListener('load', applyClass, { once: true });
    }
  }

  function initializeArticleImages() {
    var heroImage = document.querySelector('.article-template__hero-container img');
    if (heroImage) classifyImage(heroImage, true);

    document.querySelectorAll('.article-template__content img').forEach(function (image) {
      classifyImage(image, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeArticleImages, { once: true });
  } else {
    initializeArticleImages();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwm-milestone-calculator"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var root=document.querySelector('.cwm-milestone');
  if(!root)return;
  var form=root.querySelector('[data-milestone-form]');
  var input=root.querySelector('[data-milestone-date]');
  var result=root.querySelector('[data-milestone-result]');
  var error=root.querySelector('[data-milestone-error]');
  var dayCount=root.querySelector('[data-day-count]');
  var congratsHeading=root.querySelector('[data-congrats-heading]');
  var congratsCopy=root.querySelector('[data-congrats-copy]');
  var dayLabel=root.querySelector('[data-day-label]');
  var nextLabel=root.querySelector('[data-next-label]');
  var nextDistance=root.querySelector('[data-next-distance]');
  var cta=root.querySelector('[data-milestone-cta]');
  var timelineWrap=root.querySelector('[data-milestone-timeline-wrap]');
  var timeline=root.querySelector('[data-milestone-timeline]');
  var dialog=root.querySelector('[data-milestone-dialog]');
  var dialogResult=root.querySelector('[data-dialog-result]');
  var exploreButton=root.querySelector('[data-dialog-explore]');
  var offerLink=root.querySelector('[data-dialog-offer-link]');
  var celebrateLink=root.querySelector('[data-dialog-celebrate-link]');
  var primaryLink=root.querySelector('[data-dialog-primary-link]');
  var dialogShareStep=root.querySelector('[data-dialog-step="share"]');
  var dialogNextStep=root.querySelector('[data-dialog-next-step]');
  var celebrateCard=root.querySelector('[data-celebrate-card]');
  var dialogResultShop=root.querySelector('[data-dialog-result-shop]');
  var popupProductGroups=root.querySelectorAll('[data-popup-product-group]');
  var popupProductsTitle=root.querySelector('[data-popup-products-title]');
  var shareDays=root.querySelector('[data-share-days]');
  var shareNext=root.querySelector('[data-share-next]');
  var shareQuote=root.querySelector('[data-share-quote]');
  var shareCopy=root.querySelector('[data-share-copy]');
  var shareDownload=root.querySelector('[data-share-download]');
  var shareQuoteButton=root.querySelector('[data-share-quote-button]');
  var shareBackgroundButton=root.querySelector('[data-share-background-button]');
  var sharePlatformButtons=root.querySelectorAll('[data-share-platform]');
  var customQuoteInput=root.querySelector('[data-custom-quote]');
  var customPhotoInput=root.querySelector('[data-custom-photo]');
  var shareNote=root.querySelector('[data-share-note]');
  var sharePrimary=root.querySelector('[data-share-primary]');
  var shareCard=root.querySelector('[data-share-card]');
  var shareBackgroundUrls=["https://cdn.shopify.com/s/files/1/0641/6285/7207/files/cwm-milestone-forest-lake.jpg?v=1789779499","https://cdn.shopify.com/s/files/1/0641/6285/7207/files/cwm-milestone-blue-sky-mountain.jpg?v=1789779512","https://cdn.shopify.com/s/files/1/0641/6285/7207/files/cwm-milestone-mountain-road.jpg?v=1789779518","https://cdn.shopify.com/s/files/1/0641/6285/7207/files/cwm-milestone-alpine-lake.jpg?v=1789779529","https://cdn.shopify.com/s/files/1/0641/6285/7207/files/cwm-milestone-layered-mountains.jpg?v=1789779533","https://cdn.shopify.com/s/files/1/0641/6285/7207/files/cwm-milestone-mountain-sky.jpg?v=1789779266"];
  var shareBackgroundIndex=0;
  var shareBackgroundUrl=shareCard?shareCard.dataset.shareBg:shareBackgroundUrls[0];
  var shareBackgroundImage=null;
  var shareBackgroundPromise=null;
  var customPhotoUrl='';
  var shareQuotes=[
    'One day at a time.',
    'Today counts.',
    'Small steps still move you forward.',
    'Look how far you’ve come.',
    'Every day forward matters.',
    'Keep choosing the life you’re building.',
    'Your progress deserves to be seen.',
    'A brighter tomorrow is built one day at a time.',
    'This milestone carries a story.',
    'Progress is becoming part of who you are.'
  ];
  var currentShareQuote=shareQuotes[0];
  var currentShareDays='0';
  var currentShareNext='';
  var currentShareFile=null;
  var oneDay=86400000;
  var nowForMax=new Date();

  input.max=[nowForMax.getFullYear(),String(nowForMax.getMonth()+1).padStart(2,'0'),String(nowForMax.getDate()).padStart(2,'0')].join('-');

  var incomingMilestoneDate=new URLSearchParams(window.location.search).get('milestone_date');

  function localDate(value){var p=value.split('-').map(Number);return new Date(p[0],p[1]-1,p[2],12,0,0,0)}
  function dayDiff(a,b){var ua=Date.UTC(a.getFullYear(),a.getMonth(),a.getDate());var ub=Date.UTC(b.getFullYear(),b.getMonth(),b.getDate());return Math.floor((ub-ua)/oneDay)}
  function addDays(d,n){var x=new Date(d);x.setDate(x.getDate()+n);return x}
  function addMonths(d,n){var day=d.getDate();var x=new Date(d.getFullYear(),d.getMonth()+n,1,12,0,0,0);var last=new Date(x.getFullYear(),x.getMonth()+1,0).getDate();x.setDate(Math.min(day,last));return x}
  function addYears(d,n){var month=d.getMonth();var day=d.getDate();var x=new Date(d.getFullYear()+n,month,1,12,0,0,0);var last=new Date(x.getFullYear(),month+1,0).getDate();x.setDate(Math.min(day,last));return x}
  function milestoneUrl(key){
    var map={d30:'/collections/30-day-sobriety-gifts',d90:'/collections/90-day-sobriety-gifts',m6:'/collections/6-month-sobriety-gifts',y1:'/collections/1-year-sobriety-gifts',y2:'/collections/2-year-sobriety-gifts',y3:'/collections/3-year-sobriety-gifts',y5:'/collections/5-year-sobriety-gifts',y10:'/collections/10-year-sobriety-gifts',y20:'/collections/20-year-sobriety-gifts',y30:'/collections/30-year-sobriety-gifts'};
    return map[key]||'/collections/sobriety-coins';
  }
  function shopMilestone(items,now){
    var preferred=['d30','d90','m6','y1','y2','y3','y5','y10','y20','y30'];
    for(var i=0;i<preferred.length;i++){
      var item=items.find(function(entry){return entry.key===preferred[i]});
      if(item&&item.date>=now)return item;
    }
    return null;
  }
  function showPopupProducts(target){
    popupProductGroups.forEach(function(group){group.hidden=true});
    if(!target)return;
    var group=root.querySelector('[data-popup-product-group="'+target.key+'"]');
    if(group)group.hidden=false;
    if(popupProductsTitle)popupProductsTitle.textContent=target.label+' gifts picked for your next milestone';
  }
  function buildMilestones(start){
    var items=[
      {key:'d1',label:root.dataset.m1,date:addDays(start,1)},
      {key:'d7',label:root.dataset.m7,date:addDays(start,7)},
      {key:'d30',label:root.dataset.m30,date:addDays(start,30)},
      {key:'d60',label:root.dataset.m60,date:addDays(start,60)},
      {key:'d90',label:root.dataset.m90,date:addDays(start,90)},
      {key:'m6',label:root.dataset.m6m,date:addMonths(start,6)},
      {key:'y1',label:root.dataset.m1y,date:addYears(start,1)},
      {key:'y2',label:root.dataset.m2y,date:addYears(start,2)},
      {key:'y3',label:root.dataset.m3y,date:addYears(start,3)},
      {key:'y5',label:root.dataset.m5y,date:addYears(start,5)},
      {key:'y10',label:root.dataset.m10y,date:addYears(start,10)},
      {key:'y20',label:root.dataset.m20y,date:addYears(start,20)},
      {key:'y30',label:root.dataset.m30y,date:addYears(start,30)}
    ];
    for(var y=4;y<=50;y++){
      if([5,10,20,30].indexOf(y)!==-1)continue;
      items.push({key:'y'+y,label:y+' '+root.dataset.years,date:addYears(start,y)});
    }
    items.sort(function(a,b){return a.date-b.date});
    return items;
  }
  function renderTimeline(items,now,next){
    timeline.innerHTML='';
    var nextIndex=next?items.indexOf(next):items.length-1;
    var startIndex=Math.max(0,nextIndex-4);
    var endIndex=Math.min(items.length,nextIndex+4);
    items.slice(startIndex,endIndex).forEach(function(item){
      var chip=document.createElement('span');
      chip.className='cwm-milestone__chip';
      chip.textContent=item.label;
      if(item.date<=now)chip.classList.add('is-done');
      if(next&&item.key===next.key)chip.classList.add('is-next');
      timeline.appendChild(chip);
    });
  }

  function scrollToCelebrate(){
    if(celebrateCard)celebrateCard.scrollIntoView({behavior:'smooth',block:'start'});
  }
  function chooseShareQuote(){
    var nextQuote=currentShareQuote;
    if(shareQuotes.length>1){
      while(nextQuote===currentShareQuote){nextQuote=shareQuotes[Math.floor(Math.random()*shareQuotes.length)]}
    }
    currentShareQuote=nextQuote;
    if(shareQuote)shareQuote.textContent='“'+currentShareQuote+'”';
    refreshShareFile();
  }
  function setShareBackground(index){
    if(!shareBackgroundUrls.length)return;
    shareBackgroundIndex=(index+shareBackgroundUrls.length)%shareBackgroundUrls.length;
    shareBackgroundUrl=shareBackgroundUrls[shareBackgroundIndex];
    shareBackgroundImage=null;
    shareBackgroundPromise=null;
    currentShareFile=null;
    if(shareCard){
      shareCard.dataset.shareBg=shareBackgroundUrl;
      shareCard.style.setProperty('--cwm-card-photo',"url('"+shareBackgroundUrl+"')");
    }
    refreshShareFile();
  }
  function chooseShareBackground(){
    customPhotoUrl='';
    setShareBackground(shareBackgroundIndex+1);
  }
  function applyCustomQuote(){
    if(!customQuoteInput)return;
    var value=customQuoteInput.value.trim();
    if(!value)return;
    currentShareQuote=value;
    if(shareQuote)shareQuote.textContent='“'+currentShareQuote+'”';
    currentShareFile=null;
    refreshShareFile();
  }
  function applyCustomPhoto(file){
    if(!file||!file.type||file.type.indexOf('image/')!==0)return;
    if(file.size>12*1024*1024){
      if(shareNote)shareNote.textContent='Please choose an image smaller than 12 MB.';
      return;
    }
    var reader=new FileReader();
    reader.onload=function(e){
      customPhotoUrl=e.target.result;
      shareBackgroundUrl=customPhotoUrl;
      shareBackgroundImage=null;
      shareBackgroundPromise=null;
      currentShareFile=null;
      if(shareCard){
        shareCard.dataset.shareBg=shareBackgroundUrl;
        shareCard.style.setProperty('--cwm-card-photo',"url('"+shareBackgroundUrl+"')");
      }
      refreshShareFile();
      if(shareNote)shareNote.textContent='Your photo is being used for this card only.';
    };
    reader.readAsDataURL(file);
  }
  function shareCaption(){
    return '#SobrietyMilestone #CoinWithMeaning\n'+currentShareDays+' days sober today. '+currentShareQuote+'\n@CoinWithMeaning\n#RecoveryJourney';
  }
  function loadShareBackground(){
    if(shareBackgroundImage)return Promise.resolve(shareBackgroundImage);
    if(shareBackgroundPromise)return shareBackgroundPromise;
    shareBackgroundPromise=new Promise(function(resolve,reject){
      if(!shareBackgroundUrl){resolve(null);return}
      var img=new Image();
      img.crossOrigin='anonymous';
      img.onload=function(){shareBackgroundImage=img;resolve(img)};
      img.onerror=reject;
      img.src=shareBackgroundUrl;
    });
    return shareBackgroundPromise;
  }
  function drawImageCover(ctx,img,w,h){
    var scale=Math.max(w/img.width,h/img.height);
    var sw=w/scale,sh=h/scale;
    var sx=(img.width-sw)/2;
    var sy=(img.height-sh)/2;
    ctx.drawImage(img,sx,sy,sw,sh,0,0,w,h);
  }
  function drawShareCanvas(){
    return loadShareBackground().catch(function(){return null}).then(function(img){
    var canvas=document.createElement('canvas');
    canvas.width=1080;
    canvas.height=1350;
    var ctx=canvas.getContext('2d');
    if(img){drawImageCover(ctx,img,1080,1350)}else{ctx.fillStyle='#627a70';ctx.fillRect(0,0,1080,1350)}
    var overlay=ctx.createLinearGradient(0,0,0,1350);
    overlay.addColorStop(0,'rgba(18,33,30,.18)');
    overlay.addColorStop(.36,'rgba(18,33,30,.16)');
    overlay.addColorStop(.72,'rgba(18,33,30,.42)');
    overlay.addColorStop(1,'rgba(18,33,30,.62)');
    ctx.fillStyle=overlay;ctx.fillRect(0,0,1080,1350);

    ctx.textAlign='center';ctx.fillStyle='#fff8e8';
    ctx.font='700 30px Arial';ctx.fillText('COIN WITH MEANING',540,105);
    ctx.font='500 205px Georgia';ctx.fillText(currentShareDays,540,430);
    ctx.font='700 42px Arial';ctx.fillText('DAYS STRONG',540,515);
    ctx.fillStyle='#b38a52';ctx.font='50px Georgia';ctx.fillText('♡',540,620);
    ctx.fillStyle='#fffaf1';ctx.font='italic 52px Georgia';
    var words=currentShareQuote.split(' '),line='',lines=[];
    words.forEach(function(word){
      var test=line?line+' '+word:word;
      if(ctx.measureText(test).width>800&&line){lines.push(line);line=word}else{line=test}
    });
    if(line)lines.push(line);
    var quoteStart=735;
    lines.slice(0,3).forEach(function(text,index){ctx.fillText(text,540,quoteStart+(index*70))});
    ctx.font='700 28px Arial';
    ctx.fillStyle='#27483a';
    ctx.fillText('Next milestone: '+currentShareNext,540,1010);
    ctx.font='700 30px Arial';ctx.fillStyle='#fff';ctx.fillText('@CoinWithMeaning',540,1165);
    ctx.font='22px Arial';ctx.fillStyle='#f3f7f3';ctx.fillText('RECOVERY · HOPE · A BRIGHTER TOMORROW',540,1210);
    return canvas;
    });
  }
  function refreshShareFile(){
    return drawShareCanvas().then(function(canvas){
      return new Promise(function(resolve){
        canvas.toBlob(function(blob){
          if(!blob){resolve(null);return}
          currentShareFile=new File([blob],'coin-with-meaning-'+currentShareDays+'-days-strong.png',{type:'image/png'});
          resolve(currentShareFile);
        },'image/png');
      });
    });
  }
  function copyShareCaption(){
    var text=shareCaption();
    if(navigator.clipboard&&navigator.clipboard.writeText){
      return navigator.clipboard.writeText(text).then(function(){
        if(shareNote)shareNote.textContent='Caption copied.';
      }).catch(function(){});
    }
    var helper=document.createElement('textarea');
    helper.value=text;
    document.body.appendChild(helper);
    helper.select();
    document.execCommand('copy');
    helper.remove();
    if(shareNote)shareNote.textContent='Caption copied.';
    return Promise.resolve();
  }
  function canShareFile(){
    return !!(currentShareFile&&navigator.share&&navigator.canShare&&navigator.canShare({files:[currentShareFile]}));
  }
  function shareCardFile(platform){
    function performShare(){
      if(canShareFile()){
        var data={files:[currentShareFile],text:shareCaption(),title:'My sobriety milestone'};
        navigator.share(data).catch(function(){});
        if(shareNote)shareNote.textContent='Choose '+platform+' in the iPhone share sheet to post the image.';
        return;
      }
      copyShareCaption();
      if(shareNote)shareNote.textContent='This browser cannot pass the image directly. The caption was copied; use Download Card to save the image.';
    }
    if(currentShareFile){performShare();return}
    refreshShareFile().then(performShare);
  }
  function downloadShareCard(){
    if(canShareFile()){
      navigator.share({files:[currentShareFile],title:'My sobriety milestone'}).catch(function(){});
      if(shareNote)shareNote.textContent='Use Save Image or Save to Files in the iPhone share sheet.';
      return;
    }
    drawShareCanvas().then(function(canvas){
      var link=document.createElement('a');
      link.download='coin-with-meaning-'+currentShareDays+'-days-strong.png';
      link.href=canvas.toDataURL('image/png');
      document.body.appendChild(link);
      link.click();
      link.remove();
      if(shareNote)shareNote.textContent='Your milestone card download has started.';
    });
  }

  dialogNextStep.addEventListener('click',scrollToCelebrate);
  if(shareQuoteButton)shareQuoteButton.addEventListener('click',chooseShareQuote);
  if(shareBackgroundButton)shareBackgroundButton.addEventListener('click',chooseShareBackground);
  if(customQuoteInput){
    customQuoteInput.addEventListener('change',applyCustomQuote);
    customQuoteInput.addEventListener('keydown',function(e){
      if(e.key==='Enter'){e.preventDefault();applyCustomQuote()}
    });
  }
  if(customPhotoInput)customPhotoInput.addEventListener('change',function(){
    applyCustomPhoto(customPhotoInput.files&&customPhotoInput.files[0]);
  });
  if(shareCopy)shareCopy.addEventListener('click',copyShareCaption);
  if(shareDownload)shareDownload.addEventListener('click',downloadShareCard);
  if(sharePrimary)sharePrimary.addEventListener('click',function(){shareCardFile('your app')});
  sharePlatformButtons.forEach(function(button){
    button.addEventListener('click',function(){
      shareCardFile(button.dataset.sharePlatform||'your app');
    });
  });

  exploreButton.addEventListener('click',function(){
    dialog.close();
    document.getElementById('celebrate-your-milestone').scrollIntoView({behavior:'smooth',block:'start'});
  });

  offerLink.addEventListener('click',function(){dialog.close();});

  form.addEventListener('submit',function(e){
    e.preventDefault();
    error.hidden=true;
    result.hidden=true;
    timelineWrap.hidden=true;
    if(!input.value){error.textContent=root.dataset.invalid;error.hidden=false;return}
    var start=localDate(input.value);
    var now=new Date();
    now=new Date(now.getFullYear(),now.getMonth(),now.getDate(),12,0,0,0);
    if(Number.isNaN(start.getTime())||start>now){error.textContent=root.dataset.invalid;error.hidden=false;return}

    var days=dayDiff(start,now);
    var items=buildMilestones(start);
    var next=items.find(function(item){return item.date>now});
    var exact=items.find(function(item){return item.date.getTime()===now.getTime()});
    var shopTarget=shopMilestone(items,now);
    var shopUrl=shopTarget?milestoneUrl(shopTarget.key):'/collections/sobriety-coins';
    showPopupProducts(shopTarget);

    dayCount.textContent=days.toLocaleString();
    dayLabel.textContent=days===1?root.dataset.daySober:root.dataset.daysSober;

    if(exact){
      congratsHeading.textContent=root.dataset.congrats+' '+exact.label+'!';
      congratsCopy.textContent=root.dataset.exactMessage;
      dialogResult.textContent=exact.label;
      dialogResultShop.textContent=exact.label;
    }else{
      congratsHeading.textContent=root.dataset.congrats+' '+days.toLocaleString()+' '+(days===1?root.dataset.daySober:root.dataset.daysSober)+'!';
      congratsCopy.textContent=root.dataset.progressMessage;
      dialogResult.textContent=days.toLocaleString()+' '+(days===1?root.dataset.daySober:root.dataset.daysSober);
      dialogResultShop.textContent=days.toLocaleString()+' '+(days===1?root.dataset.daySober:root.dataset.daysSober);
    }

    if(next){
      var left=dayDiff(now,next.date);
      nextLabel.textContent=next.label;
      nextDistance.textContent=left+' '+(left===1?root.dataset.dayToGo:root.dataset.daysToGo);
      cta.href=shopUrl;
    }else{
      nextLabel.textContent=root.dataset.today;
      nextDistance.textContent='';
      cta.href=shopUrl;
    }

    currentShareDays=days.toLocaleString();
    currentShareNext=next?next.label:root.dataset.today;
    if(shareDays)shareDays.textContent=currentShareDays;
    if(shareNext)shareNext.textContent=currentShareNext;
    chooseShareQuote();
    refreshShareFile();
    if(dialogShareStep)dialogShareStep.hidden=false;
    dialog.scrollTop=0;

    offerLink.href=shopUrl;
    primaryLink.href=shopUrl;

    renderTimeline(items,now,next);
    result.hidden=false;
    timelineWrap.hidden=false;

    if(typeof dialog.showModal==='function'){
      window.setTimeout(function(){
        if(!dialog.open)dialog.showModal();
      },180);
    }
  });

  if(incomingMilestoneDate){
    input.value=incomingMilestoneDate;
    window.setTimeout(function(){
      if(typeof form.requestSubmit==='function'){
        form.requestSubmit();
      }else{
        form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
      }
    },120);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
